import { Icon } from "@/components/icon";
import {
	createFileRoute,
	Outlet,
	useRouteContext,
} from "@tanstack/react-router";

export const Route = createFileRoute("/_logged/c/$club/(sidebar)/(admins)")({
	component: RouteComponent,
});

function RouteComponent() {
	const { club } = useRouteContext({ from: Route.id });

	if (!club.permissions.some((p) => p.slug === "CLUB_ADMIN")) {
		return (
			<div className="size-full flex items-center justify-center p-6 gap-3 text-muted-foreground">
				<Icon name="ShieldAlert" className="size-6" />

				<span>Você não tem permissão para acessar esta página.</span>
			</div>
		);
	}

	return <Outlet />;
}
